var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.updating)?_c('div',{staticClass:"modal-backdrop d-flex text-center"},[_c('div',{staticClass:"align-self-center",staticStyle:{"flex-grow":"1"}},[_c('b-spinner',{attrs:{"variant":"white"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }